import React from "react";
import { useForm } from "react-hook-form";
import NormalInput from "component/common/NormalInput/index";
import ErrorMessage from "component/common/ErrroMessage/index";
import SaveCancelBtn from "component/common/SaveCancelBtn/index";
import { updateProfile } from "service/Auth";
import { Toast } from "utils/toast";
import jwtDecode from "jwt-decode";

const EditProfile = ({ profileTab, data }) => {
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const onSubmit = async (event) => {
    try {
      let response = await updateProfile(data._id, event);
      if (response.status == 200) {
        let token = response.data.data.token;
        localStorage.setItem("token", token);
        localStorage.setItem("user", JSON.stringify(jwtDecode(token)));
        Toast({
          type: "success",
          message: "Profile details has been updated successfully",
        });
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-md-12 mb-3">
          <NormalInput
            register={register("staffName", {
              required: true,
              pattern: /^[A-Za-z ]+$/,
              minLength: 3,
            })}
            value={data.name}
            label="Name"
            error={errors.staffName}
          />
          <ErrorMessage
            error={errors.staffName}
            message={{
              required: "Please enter name",
              minLength: "Name contain atleast 3 characters",
              pattern: "Name name contain string only",
            }}
          />
        </div>
        <div className="col-md-12 mb-3">
          <NormalInput
            register={register("phoneNumber", {
              required: true,
              pattern: /^[0-9]{10}$/,
            })}
            value={data.phoneNumber}
            label="Phone Number"
            error={errors.phoneNumber}
          />
          <ErrorMessage
            error={errors.phoneNumber}
            message={{
              required: "Please enter phone number",
              pattern: "Phone number contain 10 numbers only",
            }}
          />
        </div>
        <div className="col-md-12 mb-3">
          <NormalInput
            register={register("emailId", {
              required: true,
              pattern:
                /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
            })}
            label="Email ID"
            value={data.emailId}
            error={errors.emailId}
          />
          <ErrorMessage
            error={errors.emailId}
            message={{
              required: "Please enter email",
              pattern: "Invalid email",
            }}
          />
        </div>
      </div>
      <SaveCancelBtn
        position="center"
        onSave={handleSubmit(onSubmit)}
        onCancel={() => profileTab()}
      />
    </>
  );
};

export default EditProfile;
